import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
import './About.css';

function About() {
  let touchStartX = 0;
  let touchStartY = 0;

  useEffect(() => {
    const handleWheel = (e) => {
      // Si estamos en el tope y el usuario intenta scrollear más arriba
      if (window.scrollY === 0 && e.deltaY < 0) {
        window.location.href = '/';
      }
    };

    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchEnd = (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      const touchEndY = e.changedTouches[0].clientY;
      
      const deltaX = touchStartX - touchEndX;
      const deltaY = touchStartY - touchEndY;

      // Detectar si el movimiento es más horizontal que vertical
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        // Solo detectar movimiento hacia la derecha
        if (deltaX > 50) {
          window.location.href = '/catalog';
        }
      } else {
        // Movimientos verticales
        if (window.scrollY === 0 && deltaY < -50) {
          window.location.href = '/';
        }
      }
    };

    window.addEventListener('wheel', handleWheel);
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return (
    <motion.section 
      className="about-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div 
        className="about-content"
        initial={{ y: 20 }}
        animate={{ y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <div className="about-grid">
          <motion.div 
            className="about-card"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
          >
            <h2>Authenticity</h2>
            <p>Each game is a unique expression of art and story.</p>
          </motion.div>

          <motion.div 
            className="about-card"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
          >
            <h2>Exploration</h2>
            <p>Both players and developers are on a constant adventure.</p>
          </motion.div>

          <motion.div 
            className="about-card"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
          >
            <h2>Rebellion</h2>
            <p>Challenging the boundaries of game design with creative approaches.</p>
          </motion.div>

          <motion.div 
            className="about-card"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
          >
            <h2>Transcendence</h2>
            <p>Achieving experiences that emotionally and intellectually impact players.</p>
          </motion.div>
        </div>

        <motion.div 
          className="about-contact"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <p className="multicolor-text">
            <span className="color1">We create deep and memorable gaming experiences that allow players to </span>
            <span className="color2">explore endless possibilities </span>
            <span className="color1">through profound stories, unique aesthetics, and authentic music.</span>
          </p>
          
          <motion.div 
            className="arrow-container"
            animate={{ y: [0, 10, 0] }}
            transition={{ 
              repeat: Infinity, 
              duration: 2 
            }}
          >
            <ArrowDown className="down-arrow" size={32} color="#3fd8d8" />
          </motion.div>

          <motion.p
            className="social-media-text"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            Follow us on social media
          </motion.p>
        </motion.div>
      </motion.div>
    </motion.section>
  );
}

export default About;